import styled, { css } from 'styled-components';

export const FeedbackFormContainer = styled.div<{ $noGap?: boolean }>`
  -webkit-text-size-adjust: 100%;
  font-family: sans-serif;
  position: fixed;
  bottom: 92px;
  left: ${({ theme }) => theme.position.desktop.left};
  right: ${({ theme }) => theme.position.desktop.right};

  display: grid;
  grid-template-areas:
    'header'
    'text'
    'ratings';

  width: 360px;
  padding: 30px;
  gap: ${({ $noGap }) => {
    return $noGap == true ? '0px' : '20px';
  }};

  border-radius: 3px;

  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.35) 0 6px 100px 0;

  ${({ $isMobile }) => {
    if ($isMobile) {
      return css`
        width: -moz-available;
        width: -webkit-fill-available;
        width: auto;
        height: auto;
        bottom: 80px;
        left: auto;
        right: 5px;
        margin: 0 10px 0 10px;
      `;
    }
  }}
`;

export const FeedbackFormLogo = styled.div`
  grid-area: 'header';
  align-items: center;
  justify-self: center;
`;

export const FeedbackFormHeading = styled.div`
  padding: 10px 15px;

  grid-area: 'text';
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  width: auto;
  height: 44px;
  margin: 0;
`;

export const FeedbackFormSubheading = styled.div`
  grid-area: 'text';
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  width: 300px;
  height: 44px;

  color: #555555;
  opacity: 0.7;
  font-size: 14px;
  text-align: center;
  width: auto;
  margin: 10px 20px 0 20px;
  padding: 0;
`;

export const FeedbackFormTextArea = styled.textarea`
  border: 1px solid rgba(227, 227, 227, 1);
  min-height: 100px;
  border-radius: 3px;
  padding: 20px;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  resize: none;
`;

export const CookiePolicyText = styled.p`
  font-size: 13px;
  color: #555555;
  opacity: 0.7;
  text-align: center;
  margin-top: -20px;
`;
